'use client';

import { useEffect } from 'react';

/**
 * WEB-612 — pin `data-theme="dark"` on `<body>` for the lifetime of a
 * marketing-city layout mount.
 *
 * Mirrors the admin SPA body-lock in `_AdminApp.tsx`: Radix Dialog /
 * SearchSheet content portals to `document.body`, which is an *ancestor* of
 * the city layout root. Without this, a light ThemeProvider preference on
 * `<html>` (common on the `fallback` localhost surface) leaves portalled
 * overlays resolving `:root` light tokens — white SearchSheet panel over a
 * correctly-dark city page.
 *
 * On production `marketing-city` hosts the root layout + ThemeProvider already
 * force dark on `<html>`; this body pin is then redundant but harmless.
 * Restored on unmount so non-city navigations keep the visitor preference.
 */
export function CityDarkThemeBodyLock(): null {
  useEffect(() => {
    const { body } = document;
    const previous = body.getAttribute('data-theme');
    body.setAttribute('data-theme', 'dark');
    return () => {
      if (previous === null) {
        body.removeAttribute('data-theme');
      } else {
        body.setAttribute('data-theme', previous);
      }
    };
  }, []);

  return null;
}
